import * as React from "react";
import { Paragraph, Button, Portal, Dialog, Colors } from "react-native-paper";

const DialogConfirm = ({
  visible,
  close,
  title,
  children,
  confirm,
}: {
  visible: boolean;
  close: () => void;
  title: String;
  children: String;
  confirm: () => void;
}) => (
  <Portal>
    <Dialog
      onDismiss={close}
      style={{ backgroundColor: Colors.purple900 }}
      visible={visible}
    >
      <Dialog.Title style={{ color: Colors.white }}>
        {title || "Alert"}
      </Dialog.Title>
      <Dialog.Content>{children}</Dialog.Content>
      <Dialog.Actions>
        <Button color={Colors.white} mode="contained" onPress={confirm}>
          Yes
        </Button>
        <Button color={Colors.white} onPress={close}>
          Cancel
        </Button>
      </Dialog.Actions>
    </Dialog>
  </Portal>
);

export default DialogConfirm;
